var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.369 2.67617C10.5479 2.46576 10.8634 2.44018 11.0738 2.61902C11.2842 2.79787 11.3098 3.11341 11.131 3.32382L6.88096 8.32382C6.69931 8.53752 6.37744 8.56004 6.16781 8.3737L3.91781 6.3737C3.71142 6.19024 3.69283 5.8742 3.87628 5.66781C4.05974 5.46142 4.37578 5.44283 4.58217 5.62629L6.4501 7.28667L10.369 2.67617Z",
    fill: "#7997E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86823 3.17617C8.04707 2.96576 8.36262 2.94018 8.57302 3.11902C8.78342 3.29787 8.80901 3.61341 8.63017 3.82382L4.38017 8.82382C4.19852 9.03752 3.87665 9.06004 3.66702 8.8737L1.41702 6.8737C1.21063 6.69024 1.19203 6.3742 1.37549 6.16781C1.55895 5.96142 1.87499 5.94283 2.08138 6.12629L3.9493 7.78667L7.86823 3.17617Z",
    fill: "#2054D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCheck);
export default __webpack_public_path__ + "static/media/Double-check.b7f2b6f7d5ab5b9d71eb5422bb0da021.svg";
export { ForwardRef as ReactComponent };